import { render, staticRenderFns } from "./CardTarjaEnqueteTaNaAreaSportvWithQRCode.vue?vue&type=template&id=42d5b1d6&scoped=true"
import script from "./CardTarjaEnqueteTaNaAreaSportvWithQRCode.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteTaNaAreaSportvWithQRCode.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteTaNaAreaSportvWithQRCode.vue?vue&type=style&index=0&id=42d5b1d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d5b1d6",
  null
  
)

export default component.exports